<div class="container-fluid ml-n2">
  
  <div class="row mt-3">
    <div class="col-12 multiple-container-array-style">
      <div  v-for="item in systemListItems" class="m-2 multiple-function-container multiple-function-hover"
        :class="{ selected: selectedSystemIds.includes(item.systemId) }" v-on:click="clickItem(item.systemId)">
        <div class="function-label text-center" :class="{ 'label-ext-sm': isLangRu }">{{item.name}}</div>
      </div>
    </div>
    <div class="col-12 multi-container-array-style">
      <div class="m-3 multiple-decision-container multiple-function-hover"
        v-on:click="isDecisionEnabled ? clickDecision() : null" :class="{ 'multiple-disabled': !isDecisionEnabled }">
        <div class="decision-label text-center">{{$t('message.label_decision_button')}}</div>
      </div>
    </div>
  </div>

  <processing-view :processing="processing"></processing-view>
</div>